import React from "react";
import Testimonials from "../pages/Testimonialsabout";
import Visionn from "../pages/Visionn";

export default function AboutSection({
  statsText = "25,000+ Happy Customers Served",
  titleTop = "ABOUT AMRUTA TRAVELS",
  title = "Your Trusted Partner for Luxury & Reliable Travel",
  description = `Amruta Travels is Pune’s leading premium cab and bus rental company, 
  offering comfortable, on-time, and affordable travel for local and outstation trips. 
  Whether you’re planning an airport transfer, family vacation, wedding trip, or corporate event, 
  we provide well-maintained vehicles, professional chauffeurs, and 24×7 support for a smooth journey every time.`,
  bullets = [
    "Fleet of premium Urbania, Innova, and Tempo Travellers",
    "Professional, uniformed, and experienced drivers",
    "Affordable, transparent pricing — no hidden costs",
    "24×7 customer assistance & on-time pickups",
    "AC/Non-AC options for every group size",
  ],
  images = {
    main: "/images/bookingg.png", // Replace with your actual image path
    element: "/images/shapes/download-app-shape-2-1.png",
  },
  author = { role: "Founder & Director", name: "Amruta Travels Team" },
}) {
  return (
    <>
      {/* ===== Page Header ===== */}
      <section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content text-center">
            <h2 className="page-header__title">About Us</h2>
          </div>
        </div>
      </section>

      {/* ===== About Section ===== */}
      <div
        className="about-four section-space"
        id="about"
        style={{ backgroundColor: "#f9fafc" }}
      >
        <div className="container">
          <div className="row gutter-y-40 align-items-center">
            {/* Left Images */}
            <div className="col-lg-6">
              <div
                className="about-four__image wow fadeInLeft"
                data-wow-duration="1500ms"
                data-wow-delay="150ms"
              >
                <div
                  className="about-four__image__item"
                  style={{
                    borderRadius: "12px",
                    overflow: "hidden",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                  }}
                >
                  <img
                    src={images.main}
                    alt="Amruta Travels Fleet"
                    loading="lazy"
                    style={{ width: "100%", borderRadius: "12px" }}
                  />
                </div>
                <p
                  className="about-four__image__text fw-semibold mt-3"
                  style={{
                    background: "#0072bc",
                    color: "#fff",
                    display: "inline-block",
                    padding: "8px 16px",
                    borderRadius: "8px",
                  }}
                >
                  {/* {statsText} */}
                </p>
              </div>
            </div>

            {/* Right Content */}
            <div className="col-lg-6">
              <div className="about-four__right ps-lg-4">
                {/* Section Title */}
                <div className="sec-title">
                  <div
                    className="sec-title__top wow fadeInUp"
                    data-wow-duration="1500ms"
                    data-wow-delay="150ms"
                  >
                    <div className="sec-title__shape" />
                    <h6
                      className="sec-title__tagline text-uppercase"
                      style={{
                        color: "#0072bc",
                        fontWeight: 600,
                        letterSpacing: "1px",
                      }}
                    >
                      {titleTop}
                    </h6>
                  </div>

                  <h3
                    className="sec-title__title wow fadeInUp fw-bold"
                    data-wow-duration="1500ms"
                    data-wow-delay="200ms"
                    style={{ color: "#001f3f" }}
                  >
                    {title}
                  </h3>
                </div>

                {/* Description */}
                <p
                  className="about-four__top__text wow fadeInUp mb-4"
                  data-wow-duration="1500ms"
                  data-wow-delay="150ms"
                  style={{
                    color: "#444",
                    fontSize: "1.05rem",
                    lineHeight: "1.7",
                  }}
                >
                  {description}
                </p>

                {/* Bullets List */}
                <ul
                  className="about-four__list list-unstyled wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="150ms"
                  style={{
                    paddingLeft: 0,
                    listStyle: "none",
                    fontSize: "1rem",
                  }}
                >
                  {bullets.map((b, i) => (
                    <li
                      key={i}
                      style={{
                        marginBottom: "10px",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        color: "#333",
                      }}
                    >
                      <i
                        className="fas fa-check-circle"
                        style={{ color: "#0072bc" }}
                      />{" "}
                      {b}
                    </li>
                  ))}
                </ul>

                {/* Call Button */}
                <div className="about-four__bottom mt-4">
                  <a
                    href="tel:+918010014995"
                    className="btn btn-primary"
                    style={{
                      background: "#0072bc",
                      color: "#fff",
                      fontWeight: 600,
                      padding: "12px 28px",
                      borderRadius: "6px",
                      textDecoration: "none",
                      boxShadow: "0 6px 12px rgba(0,0,0,0.15)",
                    }}
                  >
                    📞 Call +91 8010014995
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Decorative Elements */}
        <div className="about-four__element">
          <img src={images.element} alt="" loading="lazy" />
        </div>

        <div className="about-four__shape-left">
          <div className="about-four__shape-left__one" />
          <div className="about-four__shape-left__two" />
        </div>
      </div>
<Visionn/>
      {/* ===== Testimonials Section Below About ===== */}
      <Testimonials />
    </>
  );
}
